export default __webpack_public_path__ + "static/media/banner1.3f45c674.jpg";